import { InvoiceModel } from 'models/InvoiceModel';
import { ApiBase } from 'utils/api';


type FindParams = {
    status: string,
    payer: string,
    dates?: {
        from: string,
        to: string
    },
    limit?: number,
    page?: number,
    filter?: any,
}

export default class InvoiceApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    }

    find = (params: FindParams) => this.base.axios
        .get(`/api/invoices`, {params})
        .then(res => res.data);

    get = (id: number) => this.base.axios
        .get(`/api/invoices/${id}`)
        .then(res => res.data);

    create = (data: any) => this.base.axios
        .post(`/api/invoices`, data)
        .then(res => res.data);

    createTopUp = (companyId: number, amount: number) => this.base.axios
        .post(`/api/invoices/top-up/${companyId}`, {amount})
        .then(res => res.data);

    createShippingCancellation = (carId: number) => this.base.axios
        .post(`/api/invoices/cancellation/${carId}`)
        .then(res => res.data);

    update = (data: InvoiceModel) => this.base.axios
        .put(`/api/invoices/${data.id}`, data);

    delete = (id: number) => this.base.axios
        .delete(`/api/invoices/${id}`);

    generate = (id: number) => this.base.axios
        .post(`/api/invoices/voyage/${id}`);

    paid = (id: number) => this.base.axios
        .post(`/api/invoices/${id}/paid`);

    confirm = (ids: number[], amount: number) => this.base.axios
        .post(`/api/invoices/confirm`, {amount, ids});

    storeItem = (id: number, data: any) => this.base.axios
        .post(`/api/invoices/${id}/items`, data);

    removeItem = (id: number) => this.base.axios
        .delete(`/api/invoices/items/${id}`);
}
